var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"mobile_seriesApp"}},[_c('contract-series-web')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }